import React from "react";

import { isEmpty } from "lodash/fp";

import Box from "@mui/material/Box";

import AnnotatedText, {
  SearchCompatibleAnnotatedText,
} from "@app/analytics/components/AnnotatedText";
import type { TranscriptTextChunk } from "@app/common/types";

const AnnotatedSpeech = ({
  paragraphChunk,
}: {
  paragraphChunk: TranscriptTextChunk;
}) => {
  const annotatedContentChunks = paragraphChunk.subContent ?? [];

  if (isEmpty(annotatedContentChunks)) {
    // unlikely to hit this, but just in case
    return <>{paragraphChunk.content}</>;
  }

  return (
    <Box>
      {annotatedContentChunks.map((chunk) => {
        const annotationType = chunk.annotations?.[0]?.direction;

        // if there is sub-content, that means that there is a highlight somewhere inside this
        // chunk; the outer content will be the reaction annotation and the inner content will
        // be the content chunked out by the search result highlights
        if (chunk.subContent) {
          return (
            <AnnotatedText
              key={chunk.uniqueKey}
              annotationOptions={chunk.annotationOptions}
              tooltipContent={chunk.tooltipContent}
              type={annotationType}
            >
              {chunk.subContent.map((subChunk) => {
                if (subChunk.highlighted) {
                  return (
                    <SearchCompatibleAnnotatedText
                      key={subChunk.uniqueKey}
                      type={annotationType}
                      annotationOptions={subChunk.annotationOptions}
                      highlighted
                      searchIndex={subChunk.highlightIndex}
                    >
                      {subChunk.content}
                    </SearchCompatibleAnnotatedText>
                  );
                }

                return subChunk.content;
              })}
            </AnnotatedText>
          );
        }

        return (
          <SearchCompatibleAnnotatedText
            key={chunk.uniqueKey}
            annotationOptions={chunk.annotationOptions}
            type={annotationType}
            highlighted={chunk.highlighted}
            tooltipContent={chunk.tooltipContent}
            searchIndex={chunk.highlightIndex}
          >
            {chunk.content}
          </SearchCompatibleAnnotatedText>
        );
      })}
    </Box>
  );
};

export default AnnotatedSpeech;
